import { Onboarding } from './components/Onboarding';
import { CreatorLinks } from './components/CreatorLinks';
import { CreatorInformationSections } from './staticContent/CreatorInformationSections';
import { Header } from './components/Header';
import { CaseStudies } from './components/CaseStudies';
import { IOSAppQrCodeModal } from './components/IosAppQrCodeModal';
import { Feedback } from './components/Feedback';
import { OfferModal } from './components/offerModal/OfferModal';
import { GoLiveModal } from './components/GoLiveModal';
import { LiveSuccessModal } from './components/LiveSuccessModal';
import { EducationCloseConfirmationModal } from './components/EducationCloseConfirmationModal';

import handbook from './components/handbook.png';
import community from './components/community2.png';
import { FeatureSection } from './components/FeatureSection';
import { OnboardingCard } from './components/OnboardingCard';
import { cardsSection, externalUrls } from './mappers';
import { WebinarModal } from './components/WebinarModal';
import { trackEvent } from '@services/tracking';
import { SuperTooltipModal } from './components/SuperTooltipModal';
import { HomeVM } from './home.viewModel';
import { BlackFridayChallenge } from './modals/BlackFridayChallenge';
import { faBook } from '@fortawesome/pro-solid-svg-icons';
import { Typography } from '@design-system/components/typography/typography';

export const HomeView = (p: HomeVM) => {
  const visibleCards = p.isLive
    ? cardsSection.filter((card) => card.title !== 'New to Playbook?')
    : cardsSection;

  return (
    <div className="w-full flex flex-col gap-8 max-w-[1200px] mx-auto">
      <Header {...p.headline} />
      <Onboarding {...p.onboarding} />
      <CreatorLinks {...p} />

      <FeatureSection
        title="Join our FREE Creator Community"
        description="Join a community of creators who are on the same journey as you on Playbook! Use this space to get strategy on what to offer, tips and tricks on how to grow your audience from our pros, and ask questions along the way!"
        onClick={() => p.dispatch('communityJoined')}
        ctaText="Join Community"
        imageSrc={community}
        reverse
        ctaColor="neutral"
      />

      <Typography variant="display" size="small">
        Creator Support
      </Typography>

      <div className="flex gap-4 md:flex-row flex-col">
        {visibleCards.map((card) => (
          <OnboardingCard
            key={card.title}
            title={card.title}
            subtitle={'subtitle' in card ? card.subtitle : undefined}
            description={card.description}
            image={card.image}
            link={card.link}
            isFullWidth={visibleCards.length === 1}
            onClick={() => {
              trackEvent({
                type: 'Onboarding Tile Tapped',
                payload: {
                  Title: card.title,
                  Source: p.isLive ? 'Post-Launch' : 'Pre-Launch',
                },
              });
            }}
          />
        ))}
      </div>

      <FeatureSection
        title="Need more help?"
        description="Looking for something specific? Our Help Center is easily searchable and has everything you need to know."
        onClick={() => {
          window.open(externalUrls['handbook'], '_blank');
          trackEvent({
            type: 'Onboarding Guide Tapped',
            payload: {
              Source: p.isLive ? 'Post-Launch' : 'Pre-Launch',
            },
          });
        }}
        ctaText="Help Center"
        imageSrc={handbook}
        ctaLeftIcon={faBook}
      />

      <Feedback {...p.feedback} influencerId={p.influencerId} />
      <CreatorInformationSections isLive={p.isLive} />
      <IOSAppQrCodeModal
        isOpen={p.openedModal === 'QrCode'}
        onClose={() => p.dispatch('closeModal')}
      />
      <OfferModal {...p.offerModal} />
      <EducationCloseConfirmationModal {...p.educationCloseConfirmation} />
      <GoLiveModal {...p.goLiveModal} />
      <LiveSuccessModal {...p.liveSuccessModal} />
      <WebinarModal
        isOpen={p.openedModal === 'Webinar'}
        onClose={() => p.dispatch('closeModal')}
      />
      <SuperTooltipModal
        isOpen={p.openedModal === 'SuperTooltip'}
        onClose={() => p.dispatch('closeModal')}
      />

      <BlackFridayChallenge
        isOpen={p.openedModal === 'BlackFridayChallenge'}
        onClose={() => p.dispatch('closeModal')}
      />

      <CaseStudies />
    </div>
  );
};
